import React, { useEffect, useState } from "react";
import { NavBar, TopBar } from "../../components";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PUserNavTabs } from "../../data/PUserNavTabs";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { COLLECTION, SESSION } from "../../data/constant";
import { routes } from "../../routing/routes";
import {  getDoc,getDocs,where,query ,collection} from "firebase/firestore";

function PUserRootLayout() {
  const [fullSideBar, setFullSideBar] = useState(true);
  const [showNavTopBar, setShowNavTopBar] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [userLogo, setUserLogo] = useState(null);


  useEffect(() => {
    const showTabs = PUserNavTabs.some((tab) => pathname.includes(tab.tabUrl));
    setShowNavTopBar(showTabs);
  }, [pathname, PUserNavTabs]);

  
  useEffect(() => {
    const fetchDocuments = async () =>    {
      try {
        // Retrieve session ID from local storage
        const sessionId = localStorage.getItem(SESSION.PUSER_SESSION_ID);
        if (!sessionId) {
          throw new Error("Session ID not found");
        }
  
        // Get user information based on session
        const sessionRef = doc(db, COLLECTION.PUSER_SESSION, sessionId);
        const sessionSnap = await getDoc(sessionRef);
  
        if (!sessionSnap.exists()) {
          throw new Error("Session data not found");
        }
  
        const { userId } = sessionSnap.data();

             // Query pusers  collection to find the document with matching userId
             const pusersCollectionRef = collection(db, "Pusers");
             const pusersQuery = query(pusersCollectionRef, where("userId", "==", userId));
             const pusersSnapshot = await getDocs(pusersQuery);

             if (pusersSnapshot.empty) {
              throw new Error("No matching User found");
            }
          // Assume we use the first matching Ppod document
        const pusersData = pusersSnapshot.docs[0].data();
        const { photoURL } = pusersData;
        setUserLogo(photoURL)
      } catch (error) {
        console.error("Error fetching documents:", error);
      } 
    };
  
    fetchDocuments();
  }, []);


  const logout = async () => {
    const sessionId = localStorage.getItem(SESSION.PUSER_SESSION_ID);
    localStorage.clear();
    const docRef = doc(db, COLLECTION.PUSER_SESSION, sessionId);
    await deleteDoc(docRef);
    navigate(routes.PUSER_LOGIN);
  };
  
  const topTabs = [
    { name: "Products", url: "/products" },
    { name: "FAQ", url: "/pricing" },
    { name: "Get the App", url: "/blog" },
  ];

  return (
    <main className="root-layout">
      <div className="flex-direction-column width-100-per height-100-per" >
        {showNavTopBar ? (
          <>
          <TopBar
              fullSideBar={fullSideBar}
              setFullSideBar={setFullSideBar}
              handleLogout={logout}
             // topTabs={topTabs}
              userLogo={userLogo}

/>
            <div className="afterAuthorize">
              <NavBar fullSideBar={fullSideBar} tabs={PUserNavTabs} />
              <Outlet />
            </div>
          </>
        ) : (
          <Outlet />
        )}
      </div>
    </main>
  );
}

export default PUserRootLayout;
